import {Type} from 'main.core';

export class Cookiepopup
{
	constructor(options = {name: 'Cookiepopup'})
	{
		this.name = options.name;
	}

	getCookie(name)
	{
		const cookies = document.cookie.split(';').map(cookie => cookie.trim());

		for (const cookie of cookies)
		{
			const [cookieName, cookieValue] = cookie.split('=');
			if (cookieName === name)
			{
				return decodeURIComponent(cookieValue);
			}
		}

		return null;
	}

	initButtons()
	{
		const popup = document.querySelector(".cookie-popup");
		if (!popup) return;

		const agreeButton = popup.querySelector(".cookie-popup__Y-button");
		const disagreeButton = popup.querySelector(".cookie-popup__N-button");

		if (agreeButton)
		{
			agreeButton.addEventListener("click", () =>
			{
				document.cookie = `cookieAcception=Y; max-age=${86400}; path=/`;
				popup.classList.add("cookie-popup--hidden");
			});
		}

		if (disagreeButton)
		{
			disagreeButton.addEventListener("click", () =>
			{
				document.cookie = `cookieAcception=N; max-age=${86400}; path=/`;
				popup.classList.add("cookie-popup--hidden");
			});
		}
	}

	hidePopup()
	{
		const popup = document.querySelector(".cookie-popup");
		if (!popup) return;

		const cookieValue = this.getCookie("cookieAcception");
		if (cookieValue !== null)
		{
			popup.classList.add("cookie-popup--hidden");
		}
	}

	init()
	{
		this.hidePopup();
		this.initButtons();
	}
}